import axios, { API_VERSION } from "../config";

export const getNumLogins = (params) =>
  axios.get(`${API_VERSION}/metrics/numLogins`, { params });